/**
 * Created by h3 on 2017-08-29.
 */

import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {Timeline, TimelineLite} from "gsap";
import {TeslaStateReelSymbol} from "../../reel/TeslaStateReelSymbol";
import {Tesla} from "../../Tesla";
import {TeslaGameConfig} from "../../TeslaGameConfig";
import {TeslaSoundConfig} from "../../TeslaSoundConfig";
import {StateMatrix} from "../../utils/StateMatrix";
import {TeslaSymbolUtil} from "../../utils/TeslaSymbolUtil";
import {TeslaWinAmountDisplay} from "./views/TeslaWinAmountDisplay";

export class TeslaInitialWPController extends WinPresentationController {

    protected _winSymbols:TeslaStateReelSymbol[];
    protected _noWinSymbols:TeslaStateReelSymbol[];
    private _masterTimeLine:Timeline | null;
    private _symbolStates:StateMatrix<string>;
    private _winRatioConfig:IWinRatioConfig | null;
    private _singleWin:number;
    private _totalWin:number;
    private _winAmountDisplay:TeslaWinAmountDisplay;
    private _isBigWin:boolean;
    private _symbolWinAnimation:TimelineLite;
    private _belowStakeWinRestriction:boolean;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "RocketInitialWin", skippable : true});
        this._winSymbols = [];
        this._noWinSymbols = [];
        this._winAmountDisplay = new TeslaWinAmountDisplay(StageManager.getLayer(TeslaGameConfig.instance.LAYERS.BIG_WIN.name));
    }

    protected parseFeatureGameData(data:ParsedGameData):void {
        if(this.hasWin()) {
            this._singleWin = this._gameData!.singleWin;
            this._totalWin = this._gameData!.totalWin;
            this._isBigWin = this._gameData!.isBigWin;

            this._winRatioConfig = this._gameData!.currentWinRatioConfig;
            this._symbolStates = TeslaSymbolUtil.createWinAndNoWinSymbolStateMatrix(<IBetLineWinData[]>this._betWinsData!);
            this._belowStakeWinRestriction = SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.singleWin <= data.playedBetValue);
        }
    }

    protected hasWin():boolean {
        return this._betWinsData != null && this._betWinsData.length > 0;
    }

    protected startWinPresentation():void {
        const tl:TimelineLite = new TimelineLite();

        this._winSymbols = TeslaSymbolUtil.getSymbolsWithState(this._symbolStates, TeslaGameConfig.instance.SYMBOL_STATES.win.keyword);
        this._noWinSymbols = TeslaSymbolUtil.getSymbolsWithState(this._symbolStates, TeslaGameConfig.instance.SYMBOL_STATES.noWin.keyword);

        let winRatio = 0;

        if(this._winRatioConfig) {
            winRatio = this._winRatioConfig.ratio;
        }

        let betValue:number = this._gameData && this._gameData.playedBetValue ? this._gameData.playedBetValue : 0;

        let noWinSymbolsAnimation:TimelineLite = TeslaSymbolUtil.getSymbolsNoWinAnimation(this._symbolStates.getAllCoordinatesWithState(TeslaGameConfig.instance.SYMBOL_STATES.noWin.keyword));
        let betLineAnimations:TimelineLite[] = Tesla.betLineWinView.getBetLineAnimations(<IBetLineWinData[]>this._betWinsData!);
        let gaugeAnimation:TimelineLite[] = Tesla.reelFrame.getGaugeAnimations(<IBetLineWinData[]>this._betWinsData!, betValue);
        this._symbolWinAnimation = TeslaSymbolUtil.getSymbolsWinAnimation(this._symbolStates.getAllCoordinatesWithState(TeslaGameConfig.instance.SYMBOL_STATES.win.keyword), this._winRatioConfig!);

        if (!this._belowStakeWinRestriction) {
            tl.add(() => {
                this._winAmountDisplay.individualLineAmountReset();
                this._winAmountDisplay.displayIndividualLineAmount(<IBetLineWinData[]>this._betWinsData!)
            });
            tl.add(() => Tesla.soundPlayer.playNormalWinSound(this._winRatioConfig!),)
            tl.add([
                gaugeAnimation,
                betLineAnimations
            ]);
        }

        tl.add(() => this.getWinAmountDisplaySmall(), 1);
        tl.add(this.getWinFieldAnimation(tl.totalDuration()), 1);
        tl.add(() => this.getWinAmountDisplay());
        if (!this._belowStakeWinRestriction) {
            tl.add(Tesla.background.getWinAnimation(tl.totalDuration(), winRatio), 0);
        }


        tl.add(noWinSymbolsAnimation, 0);

        let delay = 0;
        if(this._gameData!.freespinTriggeredThisSpin) {
            delay = 0.5
        }

        tl.add([
            () => this.finish(),
            () => Tesla.reelFrame.resetGaugeView()
        ], `+= ${delay}`);
        this._masterTimeLine = tl;
    }

    private getWinAmountDisplay():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        if(!this._isBigWin && this._winRatioConfig!.ratio >= 1.5) {
            tl.add(this._winAmountDisplay.getWinAmountDisplay(this._singleWin, this._winRatioConfig!));
        }

        return tl;
    }

    private getWinAmountDisplaySmall():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        if(!this._isBigWin && this._winRatioConfig!.ratio < 1.5) {
            tl.add(this._winAmountDisplay.getWinAmountDisplay(this._singleWin, this._winRatioConfig!));
            if (!this._belowStakeWinRestriction) {
                SlotGame.sound.playEffect(TeslaSoundConfig.instance.COUNT_UP_END);
            }
        }

        return tl;
    }

    private getWinFieldAnimation(duration:number):TimelineLite {
        let tl:TimelineLite = new TimelineLite();


        if(!this._isBigWin) {

            if(this._winRatioConfig!.ratio < 1.5) {
                duration = 0;
            }

            tl.add([
                () => {
                    SlotGame.winFieldController.showWinField(this._totalWin);
                    this.playCountUpSound();
                }
            ]);
        }

        return tl;
    }

    private playCountUpSound() {
        if(this._winRatioConfig!.ratio >= 1.5) {
            SlotGame.sound.playEffect(TeslaSoundConfig.instance.COUNT_UP)
        }
    }
    public abort(): void {
        if (this._isPlaying && this._skippable) {
            console.log(`[WinPresentation]-${this.moduleName}.abort()`);
            this._masterTimeLine?.timeScale(5);
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        //Stuff that happens after complete dispatch
        if(this._symbolWinAnimation) {
            this._symbolWinAnimation.timeScale(5);
        }

        if(this._masterTimeLine) {
            if(this._masterTimeLine.isActive()) {
                this._masterTimeLine.seek(this._masterTimeLine.totalDuration(), true);
                this._masterTimeLine.pause();
                this._masterTimeLine.kill();
            }
            this._masterTimeLine = null;
        }
        if(!this._isBigWin && this._winRatioConfig!.ratio >= 1.5) {
            SlotGame.sound.playEffect(TeslaSoundConfig.instance.COUNT_UP_END);
        }
        if(!this._isBigWin) {
            SlotGame.winFieldController.showWinField(this._totalWin);
        }

        SlotGame.sound.stopEffect(TeslaSoundConfig.instance.COUNT_UP);
        TeslaSymbolUtil.removeFromArrayAndSetStateToNormal(this._winSymbols);
        TeslaSymbolUtil.removeFromArrayAndSetStateToNormal(this._noWinSymbols);

        Tesla.reelFrame.resetGaugeView();
        Tesla.betLineWinView.clearView();
    }
}